import { MemberProgramType } from './member-program-type.model';
import { MemberProgram } from './member-program.model';
import { UserStatusType } from './user-status-type.model';

export class User {
  accountBalance: number;
  loginStatus: UserStatusType
  rewardsClubNumber: string;
  memberPrograms: Array<MemberProgram>;

  firstName: string;
  lastName: string;

  isEmployee: boolean;

  pin?: string;

  constructor(status: UserStatusType, rewardsClubNumber?: string) {
    this.loginStatus = status;
    this.rewardsClubNumber = rewardsClubNumber;
    this.memberPrograms = new Array<MemberProgram>();
    this.isEmployee = false;
  }
  isAmbassador() {
    return this.hasMemberProgram(MemberProgramType.AMBASSADOR);
  }
  hasMemberProgram(type: MemberProgramType) {
    return !!this.memberPrograms.find(program => program.type === type);
  }
  isExplicit() {
    return UserStatusType.isExplicit(this.loginStatus);
  }
  isAnonymous() {
    return UserStatusType.isAnonymous(this.loginStatus);
  }
  isImplicit() {
    return UserStatusType.isImplicit(this.loginStatus);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/user.model.ts